import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Download as DownloadIcon, InsertDriveFile } from "@mui/icons-material";
import { RendererProps } from "../FilePreviewModal";

interface FallbackRendererProps extends RendererProps {
  onDownload: () => void;
  reason?: string;
}

const FallbackRenderer: React.FC<FallbackRendererProps> = ({
  fileName,
  onDownload,
  reason,
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
        gap: 2,
        textAlign: "center",
      }}
    >
      <InsertDriveFile sx={{ fontSize: 96, color: "text.disabled" }} />
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        Preview not available
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
        {reason ?? `Preview is not available for "${fileName}".`}
      </Typography>
      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        onClick={onDownload}
      >
        Download
      </Button>
    </Box>
  );
};

export default FallbackRenderer;
